import * as React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';

const CustomRadioGroup = (props) => {
    return <RadioGroup {...props} />;
};

export { CustomRadioGroup as RadioGroup };
